import React, { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, CreditCard } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { PageHeader, Panel } from "../lib/ui";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function PaymentMethods() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState({ name: "", active: true });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/payment-methods").then((r) => setList(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  useEffect(() => { load(); }, []);

  const openNew = () => { setEdit(null); setForm({ name: "", active: true }); setOpen(true); };
  const openEdit = (m) => { setEdit(m); setForm({ name: m.name, active: m.active }); setOpen(true); };

  const save = async () => {
    if (!form.name.trim()) return toast.error("Nama metode wajib diisi");
    setSaving(true);
    try {
      if (edit) await api.put(`/payment-methods/${edit.id}`, form);
      else await api.post("/payment-methods", form);
      toast.success("Tersimpan"); setOpen(false); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const del = async (m) => {
    if (!window.confirm(`Hapus metode "${m.name}"?`)) return;
    try { await api.delete(`/payment-methods/${m.id}`); toast.success("Dihapus"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="payment-methods-page">
      <PageHeader title="Metode Pembayaran" subtitle="Atur metode pembayaran untuk modul Kasir">
        <Button onClick={openNew} className="bg-cocoa hover:bg-cocoa-dark text-ivory" data-testid="pm-add-btn"><Plus className="w-4 h-4 mr-1.5" /> Tambah Metode</Button>
      </PageHeader>

      <Panel>
        <Table>
          <TableHeader><TableRow className="hover:bg-transparent"><TableHead>Nama</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Aksi</TableHead></TableRow></TableHeader>
          <TableBody>
            {list.map((m) => (
              <TableRow key={m.id} data-testid={`pm-row-${m.id}`}>
                <TableCell className="font-medium text-cocoa">{m.name}</TableCell>
                <TableCell>{m.active ? <span className="text-status-passed text-sm">Aktif</span> : <span className="text-wmuted text-sm">Nonaktif</span>}</TableCell>
                <TableCell className="text-right">
                  <Button size="icon" variant="ghost" onClick={() => openEdit(m)} className="h-8 w-8 text-cocoa" data-testid={`pm-edit-${m.id}`}><Pencil className="w-4 h-4" /></Button>
                  <Button size="icon" variant="ghost" onClick={() => del(m)} className="h-8 w-8" data-testid={`pm-del-${m.id}`}><Trash2 className="w-4 h-4 text-status-reject" /></Button>
                </TableCell>
              </TableRow>
            ))}
            {!list.length && <TableRow><TableCell colSpan={3} className="text-center text-wmuted py-10"><CreditCard className="w-6 h-6 mx-auto mb-2 opacity-50" />Belum ada metode pembayaran.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Panel>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-heading text-cocoa">{edit ? "Edit Metode" : "Tambah Metode"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nama Metode</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Contoh: QRIS, GoPay, Cicilan..." data-testid="pm-name-input" /></div>
            <div className="flex items-center gap-2"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} data-testid="pm-active-switch" /><Label>Aktif</Label></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="border-taupe text-cocoa">Batal</Button>
            <Button onClick={save} disabled={saving} className="bg-cocoa hover:bg-cocoa-dark text-ivory" data-testid="pm-save-btn">{saving ? "Menyimpan..." : "Simpan"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
